<template>
  <v-app>
    <!-- Global Header with Navigation -->
    <main-header @tab-change="handleTabChange" ref="header" />
    
    <v-main>
      <div class="main-content">
        <router-view />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import MainHeader from '@/components/layout/MainHeader.vue';

export default {
  name: 'App',
  components: {
    MainHeader
  },
  data() {
    return {
      activeTab: 'standard',
      theme: 'light'
    }
  },
  methods: {
    toggleTheme() {
      this.$vuetify.theme.global.name = 
        this.$vuetify.theme.global.current.dark ? 'light' : 'dark'
    },
    
    // Handler for tab changes from header
    handleTabChange(tab) {
      this.activeTab = tab;
      
      // Mettre à jour l'onglet actif dans le store (globalement)
      this.$store.commit('ui/SET_ACTIVE_TAB', tab);
    }
  }
}
</script>

<style lang="scss">
.v-application {
  font-family: 'Roboto', sans-serif;
  background-color: #f5f5f5;
}

.main-content {
  margin-top: 112px; /* 64px (app-bar) + 48px (tabs) */
  padding-top: 16px;
  padding-bottom: 32px;
  min-height: calc(100vh - 112px);
}

.container {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 16px;
}

@media (max-width: 960px) {
  .main-content {
    margin-top: 112px; /* Both headers are kept on tablet */
  }
}

@media (max-width: 600px) {
  .main-content {
    margin-top: 112px; /* Both headers are kept on mobile */
    padding-top: 8px;
  }
  
  .container {
    padding: 0 8px;
  }
}
</style>